import React from 'react'
import Fade from 'react-reveal/Fade'

import ResponsiveContainer from 'components/utils/ResponsiveContainer'
import OrCircular from 'images/or-circular-red-01.inline.svg'
import OrDash from 'images/or-dash-red-01.inline.svg'

const PageHero = props => {

    const Background = () => {
        switch ( props.bgStyle ) {
            case 'dashed':
                return <OrDash className="absolute bottom-0 right-0 z-0 max-h-full" />
            case 'circular':
            default:
                return <OrCircular className="absolute bottom-0 right-0 z-0" />
        }
    }
    return (
        <section className="bg-primary text-white md:h-screen">
            <ResponsiveContainer className="pt-20 relative md:h-full">
                <div className="h-96 flex items-center justify-center relative z-10 md:h-full lg:w-9/12 lg:mx-auto">
                    <Fade>
                    <h1 className="text-4xl font-bold uppercase md:text-7xl lg:text-8xl">{ props.title }</h1>
                    </Fade>
                </div>
                <Background />
            </ResponsiveContainer>
        </section>
    )
}

export default PageHero
